import PropTypes from 'prop-types';
import React from 'react';
import Popup from 'reactjs-popup';
/*eslint-disable*/
const overlayStyle = {
  alignItems: 'center',
  display: 'flex',
  position: 'absolute'
};

const defaultStyles = {
  display: 'block',
  margin: 'auto',
  maxWidth: '600px',
  minWidth: '290px'
};

const Modal = ({ children, showModal, closeModal, modalBodyProps, closeOnDocumentClick }) => (
  <Popup
    contentStyle={defaultStyles}
    onClose={closeModal}
    open={showModal}
    overlayStyle={overlayStyle}
    closeOnDocumentClick={closeOnDocumentClick}
  >
    <div data-metrics-location="PU">
      {React.Children.only(React.cloneElement(children, modalBodyProps))}
    </div>
  </Popup>
);

Modal.propTypes = {
  children: PropTypes.node,
  closeModal: PropTypes.func,
  modalBodyProps: PropTypes.object,
  showModal: PropTypes.bool,
};

export default Modal;
